import { getLocale } from "../runtime";

const sv_offerwillexpire = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Erbjudandet tar slut om `
};

const offerwillexpire = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_offerwillexpire(inputs)
	return "offerWillExpire";
};

export { offerwillexpire as "offerWillExpire" };